import { render } from "./index.vue?vue&type=template&id=c23aa0e8"
import script from "./player.ts?vue&type=script&lang=js"
export * from "./player.ts?vue&type=script&lang=js"

import "./player.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script